import { Observable } from 'rxjs';

export class SessionExpiryDialogData {
  // seconds remaining before the session is automatically logged out
  countdown$: Observable<number>;
  openingDuration: string;
}
